<template>
  <audience-dashboard></audience-dashboard>
</template>

<script>
import AudienceDashboard from '@/components/analytics/AudienceDashboard';

export default {
  name: 'AudienceContainer',
  components: {
    AudienceDashboard,
  },
};
</script>




// WEBPACK FOOTER //
// AudienceContainer.vue?3dd713b7